(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"]) return;
  try {
    
const modelInput = document.getElementById('ContactModel');
const contactParams = new URLSearchParams(window.location.search);
if (modelInput && !modelInput.value) {
  const model = contactParams.get('modele') || '';
  const variant = contactParams.get('variante') || '';
  modelInput.value = [model, variant === 'Default Title' ? '' : variant].filter(Boolean).join(' — ').slice(0, 160);
}
const contactMessage = document.getElementById('ContactMessage');
if (contactMessage && !contactMessage.value && contactParams.get('motif') === 'disponibilite') contactMessage.value = contactMessage.dataset.availabilityTemplate || '';
const contactResult = document.querySelector('#NyvoltContact .nv-contact-result');
if (contactResult) contactResult.focus();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
function initNyvoltBrandTabs(root) {
  root.querySelectorAll('[data-brand-panels]:not([data-tabs-ready])').forEach((panels, groupIndex) => {
    const sections = Array.from(panels.children).filter(node => node.matches('details[data-brand-panel]'));
    if (!sections.length) return;
    const tabs = document.createElement('div');
    tabs.className = 'nv-brand-tabs';
    tabs.setAttribute('role', 'tablist');
    tabs.setAttribute('aria-label', panels.getAttribute('aria-label') || '');
    const buttons = [];
    const activate = index => {
      sections.forEach((panel, position) => {
        const selected = position === index;
        panel.hidden = !selected;
        panel.open = selected;
        buttons[position].setAttribute('aria-selected', String(selected));
        buttons[position].tabIndex = selected ? 0 : -1;
        if (selected) {
          panel.querySelectorAll('iframe[data-src]').forEach(frame => {
            frame.src = frame.dataset.src;
            frame.removeAttribute('data-src');
          });
        } else {
          panel.querySelectorAll('video').forEach(video => video.pause());
          panel.querySelectorAll('iframe[src]').forEach(frame => {
            frame.dataset.src = frame.getAttribute('src');
            frame.removeAttribute('src');
          });
        }
      });
    };
    sections.forEach((panel, index) => {
      const summary = panel.querySelector(':scope > summary');
      const prefix = panels.id || ('nyvolt-brand-' + groupIndex);
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = summary.textContent.trim();
      button.id = prefix + '-tab-' + index;
      panel.id = prefix + '-panel-' + index;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', button.id);
      panel.tabIndex = 0;
      button.addEventListener('click', () => activate(index));
      button.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % sections.length;
        else if (event.key === 'ArrowLeft') next = (index + sections.length - 1) % sections.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = sections.length - 1;
        else return;
        event.preventDefault();
        activate(next);
        buttons[next].focus();
      });
      tabs.append(button);
      buttons.push(button);
    });
    panels.before(tabs);
    panels.setAttribute('data-tabs-ready', '');
    activate(0);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initNyvoltBrandTabs(document), {once:true});
} else {
  initNyvoltBrandTabs(document);
}
document.addEventListener('shopify:section:load', event => initNyvoltBrandTabs(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-79bike"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.nv-product-chapter-mobile a');
  if (link) link.closest('details').open = false;
});
document.addEventListener('ryvolt:variant', (event) => {
  const product = event.target.closest('.nv-79bike-commerce');
  if (!product) return;
  const selected = product.querySelector('[data-variant][aria-current="true"]');
  const status = product.querySelector('[data-purchase-status]');
  if (!selected || !status) return;
  const available = selected.dataset.available === 'true';
  status.dataset.available = String(available);
  status.querySelector('[data-stock-status]').textContent = available ? status.dataset.stockLabel : status.dataset.soldOutLabel;
  status.querySelector('[data-delivery-status]').hidden = !available;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.nv-product-chapter-mobile a');
  if (link) link.closest('details').open = false;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyvolt-79bike-compare"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nv79-comparison'))customElements.define('nv79-comparison',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.querySelector('select')?.addEventListener('change',event=>{this.querySelectorAll('[data-model]').forEach(cell=>cell.classList.toggle('is-comparison',cell.dataset.model===event.target.value));});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyvolt-catalog-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nv-model-video')) {
  customElements.define('nv-model-video', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelector('button')?.addEventListener('click', () => {
        const template = this.querySelector('template');
        if (!template) return;
        this.append(template.content.cloneNode(true));
        this.querySelector('button')?.remove();
        this.querySelector('iframe')?.focus();
      }, { once: true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyvolt-discover"] && !Shopify.designMode) return;
  try {
    
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.animate([{transform:'translateY(16px)',opacity:.75},{transform:'translateY(0)',opacity:1}],{duration:500,easing:'cubic-bezier(.2,.7,.3,1)'});
      observer.unobserve(entry.target);
    });
  },{threshold:.12});
  document.querySelectorAll('[data-nv-enter]').forEach(el=>observer.observe(el));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyvolt-dualtron-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function mount(root) {
      if (root.dataset.dtReady) return;
      const dataNode = root.querySelector('[data-dt-data]');
      if (!dataNode) return;
      const data = JSON.parse(dataNode.textContent);
      const selects = Array.from(root.querySelectorAll('[data-dt-option]'));
      const variants = data.variants;
      if (!variants.length) return;
      root.dataset.dtReady = 'true';
      const image = root.querySelector('.nv-dt__image');
      const ribbon = root.querySelector('[data-dt-ribbon]');
      const availability = root.querySelector('[data-dt-availability]');
      const stock = root.querySelector('[data-dt-stock]');
      const eta = root.querySelector('[data-dt-eta]');
      const buy = root.querySelector('[data-dt-buy]');
      const sticky = root.querySelector('[data-dt-sticky]');
      const stickyButton = root.querySelector('[data-dt-sticky-button]');
      const stickyPrice = root.querySelector('[data-dt-sticky-price]');
      const question = root.querySelector('[data-dt-question]');
      const availabilityQuestion = root.querySelector('[data-dt-availability-question]');
      const idInput = root.querySelector('[data-dt-variant-id]');
      const form = root.querySelector('form');
      let active = variants.find(v => v.id === data.selectedId) || variants[0];
      let canBuy = false;
      const galleryNode = root.querySelector('[data-dt-gallery]');
      const galleryCount = root.querySelector('[data-dt-gallery-count]');
      const zoomDialog = root.querySelector('[data-dt-zoom]');
      const zoomImage = root.querySelector('[data-dt-zoom-image]');
      let photos = [];
      let photoIndex = 0;
      function showPhoto(index) {
        if (!photos[index]) return;
        photoIndex = index;
        const photo = photos[index];
        image.removeAttribute('srcset');
        image.src = photo.url;
        image.alt = photo.alt;
        root.querySelector('[data-dt-caption]').textContent = index === 0 ? active.title : photo.alt;
        galleryNode.querySelectorAll('[data-dt-photo]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.dtPhoto) === index)));
        galleryCount.textContent = data.labels.photoOf.replace('__CURRENT__', String(index + 1)).replace('__TOTAL__', String(photos.length));
      }
      function renderGallery() {
        const seen = new Set();
        const candidates = [{url:active.image,alt:root.querySelector('h1').textContent + ' - ' + active.title}, ...(Array.isArray(active.config?.gallery) ? active.config.gallery : [])];
        photos = candidates.filter(photo => {
          if (!photo?.url || seen.has(photo.url)) return false;
          seen.add(photo.url);
          return true;
        });
        galleryNode.replaceChildren();
        photos.forEach((photo,index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.dtPhoto = String(index);
          button.setAttribute('aria-label',data.labels.viewPhoto.replace('__NUMBER__',String(index + 1)));
          button.setAttribute('aria-pressed',String(index === 0));
          const thumbnail = document.createElement('img');
          const thumbnailUrl = new URL(photo.url, window.location.origin);
          thumbnailUrl.searchParams.set('width','160');
          thumbnail.src = thumbnailUrl.href;
          thumbnail.alt = '';
          thumbnail.width = 72;
          thumbnail.height = 72;
          thumbnail.loading = 'lazy';
          button.append(thumbnail);
          galleryNode.append(button);
        });
        galleryNode.hidden = photos.length < 2;
        galleryCount.hidden = photos.length < 2;
        showPhoto(0);
      }
      galleryNode.addEventListener('click', event => {
        const button = event.target.closest('[data-dt-photo]');
        if (button) showPhoto(Number(button.dataset.dtPhoto));
      });
      function openZoom() {
        const photo = photos[photoIndex];
        if (!photo) return;
        zoomImage.src = photo.url;
        zoomImage.alt = photo.alt;
        if (!zoomDialog.open) zoomDialog.showModal();
      }
      root.querySelector('[data-dt-zoom-open]').addEventListener('click',openZoom);
      image.addEventListener('click',openZoom);
      root.querySelector('[data-dt-zoom-close]').addEventListener('click',() => zoomDialog.close());
      zoomDialog.addEventListener('click',event => { if (event.target === zoomDialog) zoomDialog.close(); });

      function resolve(changedIndex) {
        const desired = selects.map(select => select.value);
        let candidates = variants;
        for (let i = 0; i < selects.length; i++) {
          const values = new Set(candidates.map(v => v.options[i]));
          Array.from(selects[i].options).forEach(option => { option.disabled = !values.has(option.value); });
          if (!values.has(desired[i])) desired[i] = candidates[0].options[i];
          selects[i].value = desired[i];
          candidates = candidates.filter(v => v.options[i] === desired[i]);
        }
        active = candidates[0];
        render(changedIndex !== undefined);
      }
      function updateSticky() {
        sticky.hidden = !canBuy || !matchMedia('(max-width:749px)').matches || buy.getBoundingClientRect().bottom >= 0;
      }
      addEventListener('scroll', updateSticky, {passive:true});
      addEventListener('resize', updateSticky, {passive:true});
      function render(updateUrl) {
        const config = active.config || {availability: 'out_of_stock'};
        const pricePending = typeof config.price_confirmed === 'boolean' ? !config.price_confirmed : data.pricePending;
        const status = config.availability || 'out_of_stock';
        const previousVariantId = idInput.value;
        idInput.value = active.id;
        if (previousVariantId !== String(active.id)) idInput.dispatchEvent(new Event('change', {bubbles:true}));
        root.querySelector('[data-dt-sku]').textContent = active.sku;
        root.querySelector('[data-dt-caption]').textContent = active.title;
        root.querySelector('[data-dt-details-variant]').textContent = active.title;
        root.querySelector('[data-dt-battery-current]').hidden = !config.battery;
        root.querySelector('[data-dt-battery-value]').textContent = config.battery || '';
        availability.dataset.status = status;
        stock.textContent = data.labels[status] || data.labels.out_of_stock;
        ribbon.hidden = config.preorder !== true;
        renderGallery();
        eta.hidden = !config.eta;
        if (config.eta) {
          const date = new Date(config.eta + 'T12:00:00Z');
          eta.textContent = data.labels.arrival + ' ' + new Intl.DateTimeFormat(document.documentElement.lang || 'fr').format(date);
        }
        ['battery', 'color', 'version'].forEach(key => {
          root.querySelector('[data-dt-spec="' + key + '"]').textContent = config[key] || '';
          root.querySelector('[data-dt-spec-row="' + key + '"]').hidden = !config[key];
          root.querySelector('[data-dt-detail="' + key + '"]').textContent = config[key] || '';
          root.querySelector('[data-dt-detail-row="' + key + '"]').hidden = !config[key];
        });
        root.querySelector('[data-dt-price]').textContent = pricePending ? data.labels.pricePending : new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency', currency:data.currency}).format(active.price / 100);
        canBuy = !pricePending && data.commerceEnabled && active.available && status !== 'out_of_stock';
        buy.disabled = !canBuy;
        const paymentTerms = root.querySelector('[data-dt-payment-terms]');
        if (paymentTerms) paymentTerms.hidden = !canBuy;
        buy.textContent = pricePending ? data.labels.pricePending : status === 'out_of_stock' ? data.labels.out_of_stock : !data.commerceEnabled ? data.labels.contact : config.preorder ? data.labels.preorderButton : data.labels.addToCart;
        stickyButton.textContent = buy.textContent;
        stickyButton.disabled = buy.disabled;
        stickyPrice.textContent = root.querySelector('[data-dt-price]').textContent;
        for (const link of [question, availabilityQuestion]) {
          const target = new URL(link.href, location.origin);
          target.searchParams.set('variante', active.title);
          link.href = target.toString();
        }
        availabilityQuestion.hidden = status !== 'preorder' && status !== 'out_of_stock';
        updateSticky();
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', active.id);
          window.history.replaceState({}, '', url);
        }
      }
      selects.forEach((select, index) => select.addEventListener('change', () => resolve(index)));
      form.addEventListener('submit', event => { if (!canBuy) event.preventDefault(); });
      window.addEventListener('popstate', () => {
        const id = Number(new URL(window.location.href).searchParams.get('variant'));
        const found = variants.find(v => v.id === id);
        if (found) { active = found; selects.forEach((select, i) => { select.value = found.options[i]; }); resolve(); }
      });
      resolve();
    }
    function mountAll(scope = document) { scope.querySelectorAll('[data-dualtron-product]').forEach(mount); }
    mountAll();
    document.addEventListener('shopify:section:load', event => mountAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyvolt-home-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nyvolt-home-carousel')) {
  customElements.define('nyvolt-home-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.slides = Array.from(this.querySelectorAll('.nvc-slide'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches || Boolean(navigator.connection?.saveData);
      this.inView = false;
      this.focused = false;
      this.events = new AbortController();
      const on = (target, event, callback, options = {}) => target.addEventListener(event, callback, {...options, signal:this.events.signal});
      const controls = this.querySelector('[data-carousel-controls]');
      if (controls) controls.hidden = false;
      on(this, 'click', event => {
        const button = event.target.closest('[data-slide-index], [data-carousel-previous], [data-carousel-next], [data-carousel-toggle]');
        if (!button) return;
        if (button.hasAttribute('data-carousel-toggle')) {
          this.paused = !this.paused;
          this.focused = false;
          this.hovered = false;
          this.updatePause();
          this.schedule();
          return;
        }
        this.paused = true;
        const target = button.hasAttribute('data-slide-index') ? Number(button.dataset.slideIndex) : this.index + (button.hasAttribute('data-carousel-next') ? 1 : -1);
        this.show(target, true);
      });
      on(this, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
      on(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => { this.focused = true; this.schedule(); });
      on(this, 'focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } });
      on(this, 'keydown', event => {
        if (event.target.closest('input, textarea, select') || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true); }
      });
      const stage = this.querySelector('.nvc-stage');
      on(stage, 'pointerdown', event => { this.swiped = false; if (event.pointerType === 'touch') this.touch = {x:event.clientX, y:event.clientY}; }, {passive:true});
      on(stage, 'pointerup', event => {
        if (!this.touch) return;
        const x = event.clientX - this.touch.x, y = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(x) > 45 && Math.abs(x) > Math.abs(y) * 1.4) { this.swiped = true; this.show(this.index + (x < 0 ? 1 : -1), true); }
      }, {passive:true});
      on(stage, 'click', event => { if (this.swiped) { event.preventDefault(); this.swiped = false; } }, {capture:true});
      on(stage, 'pointercancel', () => { this.touch = null; });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.reduced, 'change', event => { if (event.matches) { this.paused = true; this.updatePause(); this.schedule(); } });
      on(document, 'shopify:block:select', event => { const slide = event.target.closest('.nvc-slide'); if (slide && this.contains(slide)) this.show(this.slides.indexOf(slide), true); });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, {threshold:0.2});
        this.observer.observe(this);
      } else { this.inView = true; }
      this.updatePause();
      this.schedule();
    }
    show(next, manual = false) {
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        if (active) slide.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      });
      this.querySelectorAll('[data-slide-index]').forEach(button => button.setAttribute('aria-current', String(Number(button.dataset.slideIndex) === this.index)));
      const counter = this.querySelector('[data-current-slide]');
      const title = this.querySelector('[data-current-title]');
      if (counter) counter.textContent = String(this.index + 1).padStart(2, '0');
      if (title) title.textContent = this.slides[this.index].dataset.title;
      if (manual) this.querySelector('[data-announcement]').textContent = this.slides[this.index].getAttribute('aria-label');
      this.updatePause();
      this.schedule();
    }
    updatePause() {
      this.classList.toggle('is-paused', this.paused);
      const toggle = this.querySelector('[data-carousel-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-pressed', String(!this.paused));
        toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      }
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.focused || this.hovered || !this.inView || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 7000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.events?.abort();
      this.events = null;
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyvolt-home-mobility"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nv-home-hero')) {
  customElements.define('nv-home-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const on = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: this.events.signal });
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.dots = [...this.querySelectorAll('[data-hero-dot]')];
      if (this.slides.length < 2 || this.dots.length !== this.slides.length) return;
      this.index = 0;
      this.classList.add('is-ready');
      this.slides.forEach(slide => { slide.hidden = false; });
      this.querySelector('[data-hero-controls]').hidden = false;
      this.dots.forEach((dot, index) => on(dot, 'click', () => this.show(index)));
      on(this, 'keydown', event => {
        if (event.target.closest('input,select,textarea') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.show(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      const stage = this.querySelector('[data-hero-stage]');
      on(stage, 'pointerdown', event => {
        if (event.pointerType === 'mouse' || event.target.closest('a,button,input,select,textarea')) return;
        this.swipe = { x: event.clientX, y: event.clientY };
        stage.setPointerCapture(event.pointerId);
      });
      on(stage, 'pointerup', event => {
        if (!this.swipe) return;
        const dx = event.clientX - this.swipe.x;
        const dy = event.clientY - this.swipe.y;
        this.swipe = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) this.show(this.index + (dx < 0 ? 1 : -1));
      });
      on(stage, 'pointercancel', () => { this.swipe = null; });
      this.video = this.querySelector('[data-hero-video]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = true;
      if (this.video) {
        on(this.video, 'playing', () => this.video.classList.add('is-playing'));
        on(this.video, 'error', () => this.video.classList.remove('is-playing'));
        on(this.motion, 'change', () => this.updateVideo());
        on(document, 'visibilitychange', () => { this.updateVideo(); this.schedule(); });
        on(window, 'resize', () => this.updateVideo(), {passive:true});
        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.updateVideo();
            this.schedule();
          }, {threshold: 0.1});
          this.videoObserver.observe(this);
        }
        this.updateVideo();
      }
      on(this, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
      on(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => { this.focused = true; this.schedule(); });
      on(this, 'focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } });
      on(this.motion, 'change', () => this.schedule());
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.manual || this.hovered || this.focused || !this.inView || this.motion.matches || navigator.connection?.saveData || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1, false), this.index === 0 ? 14000 : 9000);
    }
    updateVideo() {
      if (!this.video) return;
      const allowed = this.index === 0 && this.inView && !this.motion.matches && !navigator.connection?.saveData && document.visibilityState !== 'hidden';
      if (!allowed) {
        this.video.pause();
        if (this.motion.matches) this.video.classList.remove('is-playing');
        return;
      }
      const source = matchMedia('(max-width: 749px)').matches ? this.video.dataset.mobileSrc : this.video.dataset.desktopSrc;
      if (!source) return;
      if (this.video.dataset.loadedSource !== source) {
        this.video.classList.remove('is-playing');
        this.video.src = source;
        this.video.dataset.loadedSource = source;
        this.video.load();
      }
      this.video.muted = true;
      const promise = this.video.play();
      if (promise) promise.catch(() => this.video.classList.remove('is-playing'));
    }
    show(index, manual = true) {
      if (manual) this.manual = true;
      const next = (index + this.slides.length) % this.slides.length;
      if (next !== this.index && this.slides[this.index].contains(document.activeElement)) this.dots[next].focus({ preventScroll: true });
      this.index = next;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === next);
        slide.inert = i !== next;
        slide.setAttribute('aria-hidden', String(i !== next));
      });
      this.dots.forEach((dot, i) => { if (i === next) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      if (manual) this.querySelector('[data-hero-status]').textContent = `${next + 1} / ${this.slides.length} · ${this.slides[next].getAttribute('aria-label')}`;
      this.updateVideo();
      this.schedule();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.videoObserver?.disconnect();
      this.video?.pause();
      this.events?.abort();
      this.events = null;
    }
  });
}
if (!customElements.get('nv-home-product-rail')) {
  customElements.define('nv-home-product-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const on = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: this.events.signal });
      this.track = this.querySelector('[data-product-rail]');
      this.previous = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const move = direction => {
        const card = this.track.firstElementChild;
        if (!card) return;
        const distance = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0);
        this.track.scrollBy({ left: distance * direction, behavior: this.motion.matches ? 'instant' : 'smooth' });
      };
      on(this.previous, 'click', () => move(-1));
      on(this.next, 'click', () => move(1));
      on(this.track, 'scroll', () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.update()); }, { passive: true });
      on(this.track, 'keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.motion.matches ? 'instant' : 'smooth' });
        else move(event.key === 'ArrowRight' ? 1 : -1);
      });
      on(this.track, 'pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button,input,select,textarea,label,summary')) return;
        this.drag = { id: event.pointerId, start: event.clientX, scroll: this.track.scrollLeft, moved: false };
        this.blockClickUntil = 0;
      });
      on(this.track, 'dragstart', event => { if (this.drag) event.preventDefault(); });
      on(this.track, 'pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const dx = event.clientX - this.drag.start;
        if (!this.drag.moved && Math.abs(dx) < 6) return;
        if (!this.drag.moved) { this.drag.moved = true; this.track.setPointerCapture(event.pointerId); this.track.classList.add('is-dragging'); }
        event.preventDefault();
        this.track.scrollLeft = this.drag.scroll - dx;
      });
      const finish = () => {
        if (!this.drag) return;
        if (this.drag.moved) this.blockClickUntil = performance.now() + 350;
        if (this.track.hasPointerCapture(this.drag.id)) this.track.releasePointerCapture(this.drag.id);
        this.drag = null;
        this.track.classList.remove('is-dragging');
        this.update();
      };
      on(this.track, 'pointerup', finish);
      on(this.track, 'pointercancel', finish);
      on(this.track, 'pointerleave', () => { if (this.drag && !this.drag.moved) finish(); });
      on(this.track, 'click', event => { if (performance.now() < (this.blockClickUntil || 0)) { event.preventDefault(); event.stopPropagation(); } }, { capture: true });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      this.querySelector('[data-rail-controls]').hidden = max <= 2;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.events?.abort();
      this.events = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyvolt-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const key = 'nyvolt-newsletter-dismissed-v2';
    let previousFocus, automaticDone = false, delayElapsed = false;
    const dismissed = () => { try { return sessionStorage.getItem(key) === '1'; } catch { return automaticDone; } };
    const open = () => {
      if (!root.isConnected || dialog.open || document.querySelector('dialog[open]')) return false;
      previousFocus = document.activeElement;
      dialog.showModal();
      dialog.focus({preventScroll:true});
      return true;
    };
    const close = () => {
      dialog.close();
      automaticDone = true;
      try { sessionStorage.setItem(key,'1'); } catch {}
      if (previousFocus?.isConnected) previousFocus.focus({preventScroll:true});
    };
    root.querySelectorAll('[data-nv-signup-close]').forEach(button => button.addEventListener('click',close));
    document.querySelectorAll('[data-nv-signup-open]').forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-controls',dialog.id);
      button.addEventListener('click',() => { if (open()) automaticDone = true; });
    });
    dialog.addEventListener('cancel',event => { event.preventDefault(); close(); });
    dialog.addEventListener('click',event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    const maybeOpen = () => {
      if (automaticDone || dismissed() || !delayElapsed || window.scrollY < 320 || document.visibilityState === 'hidden') return;
      if (document.activeElement?.matches('input,select,textarea,[contenteditable="true"]')) return;
      if (open()) { automaticDone = true; window.removeEventListener('scroll',maybeOpen); }
    };
    if (root.dataset.automatic === 'true' && !dismissed()) {
      window.addEventListener('scroll',maybeOpen,{passive:true});
      setTimeout(() => { delayElapsed = true; maybeOpen(); },25000);
    }
    if (root.querySelector('[data-nv-signup-result]') || root.dataset.designMode === 'true') open();
  };
  document.querySelectorAll('[data-nv-signup]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-nv-signup]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyvolt-scooter-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function mount(root) {
      if (root.dataset.dtReady) return;
      const dataNode = root.querySelector('[data-dt-data]');
      if (!dataNode) return;
      const data = JSON.parse(dataNode.textContent);
      const selects = Array.from(root.querySelectorAll('[data-dt-option]'));
      const variants = data.variants;
      if (!variants.length) return;
      root.dataset.dtReady = 'true';
      const image = root.querySelector('.nv-dt__image');
      const ribbon = root.querySelector('[data-dt-ribbon]');
      const availability = root.querySelector('[data-dt-availability]');
      const stock = root.querySelector('[data-dt-stock]');
      const eta = root.querySelector('[data-dt-eta]');
      const buy = root.querySelector('[data-dt-buy]');
      const sticky = root.querySelector('[data-dt-sticky]');
      const stickyButton = root.querySelector('[data-dt-sticky-button]');
      const stickyPrice = root.querySelector('[data-dt-sticky-price]');
      const question = root.querySelector('[data-dt-question]');
      const availabilityQuestion = root.querySelector('[data-dt-availability-question]');
      const idInput = root.querySelector('[data-dt-variant-id]');
      const form = root.querySelector('form');
      let active = variants.find(v => v.id === data.selectedId) || variants[0];
      let canBuy = false;
      const galleryNode = root.querySelector('[data-dt-gallery]');
      const galleryCount = root.querySelector('[data-dt-gallery-count]');
      const zoomDialog = root.querySelector('[data-dt-zoom]');
      const zoomImage = root.querySelector('[data-dt-zoom-image]');
      let photos = [];
      let photoIndex = 0;
      function showPhoto(index) {
        if (!photos[index]) return;
        photoIndex = index;
        const photo = photos[index];
        image.removeAttribute('srcset');
        image.src = photo.url;
        image.alt = photo.alt;
        root.querySelector('[data-dt-caption]').textContent = index === 0 ? active.title : photo.alt;
        galleryNode.querySelectorAll('[data-dt-photo]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.dtPhoto) === index)));
        galleryCount.textContent = data.labels.photoOf.replace('__CURRENT__', String(index + 1)).replace('__TOTAL__', String(photos.length));
      }
      function renderGallery() {
        const seen = new Set();
        const candidates = [{url:active.image,alt:root.querySelector('h1').textContent + ' - ' + active.title}, ...(Array.isArray(active.config?.gallery) ? active.config.gallery : [])];
        photos = candidates.filter(photo => {
          if (!photo?.url || seen.has(photo.url)) return false;
          seen.add(photo.url);
          return true;
        });
        galleryNode.replaceChildren();
        photos.forEach((photo,index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.dtPhoto = String(index);
          button.setAttribute('aria-label',data.labels.viewPhoto.replace('__NUMBER__',String(index + 1)));
          button.setAttribute('aria-pressed',String(index === 0));
          const thumbnail = document.createElement('img');
          const thumbnailUrl = new URL(photo.url, window.location.origin);
          thumbnailUrl.searchParams.set('width','160');
          thumbnail.src = thumbnailUrl.href;
          thumbnail.alt = '';
          thumbnail.width = 72;
          thumbnail.height = 72;
          thumbnail.loading = 'lazy';
          button.append(thumbnail);
          galleryNode.append(button);
        });
        galleryNode.hidden = photos.length < 2;
        galleryCount.hidden = photos.length < 2;
        showPhoto(0);
      }
      galleryNode.addEventListener('click', event => {
        const button = event.target.closest('[data-dt-photo]');
        if (button) showPhoto(Number(button.dataset.dtPhoto));
      });
      function openZoom() {
        const photo = photos[photoIndex];
        if (!photo) return;
        zoomImage.src = photo.url;
        zoomImage.alt = photo.alt;
        if (!zoomDialog.open) zoomDialog.showModal();
      }
      root.querySelector('[data-dt-zoom-open]').addEventListener('click',openZoom);
      image.addEventListener('click',openZoom);
      root.querySelector('[data-dt-zoom-close]').addEventListener('click',() => zoomDialog.close());
      zoomDialog.addEventListener('click',event => { if (event.target === zoomDialog) zoomDialog.close(); });

      function resolve(changedIndex) {
        const desired = selects.map(select => select.value);
        let candidates = variants;
        for (let i = 0; i < selects.length; i++) {
          const values = new Set(candidates.map(v => v.options[i]));
          Array.from(selects[i].options).forEach(option => { option.disabled = !values.has(option.value); });
          if (!values.has(desired[i])) desired[i] = candidates[0].options[i];
          selects[i].value = desired[i];
          candidates = candidates.filter(v => v.options[i] === desired[i]);
        }
        active = candidates[0];
        render(changedIndex !== undefined);
      }
      function updateSticky() {
        sticky.hidden = !canBuy || !matchMedia('(max-width:749px)').matches || buy.getBoundingClientRect().bottom >= 0;
      }
      addEventListener('scroll', updateSticky, {passive:true});
      addEventListener('resize', updateSticky, {passive:true});
      function render(updateUrl) {
        const config = active.config || {availability: 'out_of_stock'};
        const pricePending = typeof config.price_confirmed === 'boolean' ? !config.price_confirmed : data.pricePending;
        const status = config.availability || 'out_of_stock';
        const previousVariantId = idInput.value;
        idInput.value = active.id;
        if (previousVariantId !== String(active.id)) idInput.dispatchEvent(new Event('change', {bubbles:true}));
        root.querySelector('[data-dt-sku]').textContent = active.sku;
        root.querySelector('[data-dt-caption]').textContent = active.title;
        root.querySelector('[data-dt-details-variant]').textContent = active.title;
        root.querySelector('[data-dt-battery-current]').hidden = !config.battery;
        root.querySelector('[data-dt-battery-value]').textContent = config.battery || '';
        availability.dataset.status = status;
        stock.textContent = data.labels[status] || data.labels.out_of_stock;
        ribbon.hidden = config.preorder !== true;
        renderGallery();
        eta.hidden = !config.eta;
        if (config.eta) {
          const date = new Date(config.eta + 'T12:00:00Z');
          eta.textContent = data.labels.arrival + ' ' + new Intl.DateTimeFormat(document.documentElement.lang || 'fr').format(date);
        }
        ['battery', 'color', 'version'].forEach(key => {
          root.querySelector('[data-dt-spec="' + key + '"]').textContent = config[key] || '';
          root.querySelector('[data-dt-spec-row="' + key + '"]').hidden = !config[key];
          root.querySelector('[data-dt-detail="' + key + '"]').textContent = config[key] || '';
          root.querySelector('[data-dt-detail-row="' + key + '"]').hidden = !config[key];
        });
        root.querySelector('[data-dt-price]').textContent = pricePending ? data.labels.pricePending : new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency', currency:data.currency}).format(active.price / 100);
        canBuy = !pricePending && data.commerceEnabled && active.available && status !== 'out_of_stock';
        buy.disabled = !canBuy;
        const paymentTerms = root.querySelector('[data-dt-payment-terms]');
        if (paymentTerms) paymentTerms.hidden = !canBuy;
        buy.textContent = pricePending ? data.labels.pricePending : status === 'out_of_stock' ? data.labels.out_of_stock : !data.commerceEnabled ? data.labels.contact : config.preorder ? data.labels.preorderButton : data.labels.addToCart;
        stickyButton.textContent = buy.textContent;
        stickyButton.disabled = buy.disabled;
        stickyPrice.textContent = root.querySelector('[data-dt-price]').textContent;
        for (const link of [question, availabilityQuestion]) {
          const target = new URL(link.href, location.origin);
          target.searchParams.set('variante', active.title);
          link.href = target.toString();
        }
        availabilityQuestion.hidden = status !== 'preorder' && status !== 'out_of_stock';
        updateSticky();
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', active.id);
          window.history.replaceState({}, '', url);
        }
      }
      selects.forEach((select, index) => select.addEventListener('change', () => resolve(index)));
      form.addEventListener('submit', event => { if (!canBuy) event.preventDefault(); });
      window.addEventListener('popstate', () => {
        const id = Number(new URL(window.location.href).searchParams.get('variant'));
        const found = variants.find(v => v.id === id);
        if (found) { active = found; selects.forEach((select, i) => { select.value = found.options[i]; }); resolve(); }
      });
      resolve();
    }
    function mountAll(scope = document) { scope.querySelectorAll('[data-dualtron-product]').forEach(mount); }
    mountAll();
    document.addEventListener('shopify:section:load', event => mountAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ryvolt-modeles"] && !Shopify.designMode) return;
  try {
    
function initRyvoltRange(root){
  const ranges=root.matches?.('[data-rv-range]')?[root]:root.querySelectorAll('[data-rv-range]');
  ranges.forEach((range)=>{
    if(range.dataset.rvReady)return;range.dataset.rvReady='true';
    const tablist=range.querySelector('[data-rv-tabs]');const tabs=Array.from(range.querySelectorAll('[data-rv-tab]'));const panels=Array.from(range.querySelectorAll('[data-rv-panel]'));
    if(!tabs.length)return;
    const select=(key,focus=false)=>{
      tabs.forEach((tab)=>{const active=tab.dataset.rvTab===key;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;if(active&&focus)tab.focus()});
      panels.forEach((panel)=>{panel.hidden=panel.dataset.rvPanel!==key;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tabs.find((tab)=>tab.dataset.rvTab===panel.dataset.rvPanel).id)});
    };
    tablist.hidden=false;select(tabs[0].dataset.rvTab);
    tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>select(tab.dataset.rvTab));
      tab.addEventListener('keydown',(event)=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();select(tabs[next].dataset.rvTab,true)});
    });
    range.addEventListener('shopify:block:select',(event)=>{if(event.detail?.blockId)select(event.detail.blockId)});
  });
}
initRyvoltRange(document);
document.addEventListener('shopify:section:load',(event)=>initRyvoltRange(event.target));

  } catch(e) { console.error(e); }
})();
})();
